/**
 * @generated SignedSource<<9d6f4748fd388d2aac79a30155a8414d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotosSearchBrowseFirmDetailsRenderer_searchBrowsePhoto$data = {
  readonly caption: string | null;
  readonly designFirm: {
    readonly name: string | null;
    readonly serviceId: string | null;
    readonly urlLabel: string | null;
  } | null;
  readonly project: {
    readonly name: string | null;
    readonly url: string | null;
  } | null;
  readonly " $fragmentType": "PhotosSearchBrowseFirmDetailsRenderer_searchBrowsePhoto";
};
export type PhotosSearchBrowseFirmDetailsRenderer_searchBrowsePhoto$key = {
  readonly " $data"?: PhotosSearchBrowseFirmDetailsRenderer_searchBrowsePhoto$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseFirmDetailsRenderer_searchBrowsePhoto">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotosSearchBrowseFirmDetailsRenderer_searchBrowsePhoto",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "caption",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignFirm",
      "kind": "LinkedField",
      "name": "designFirm",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLabel",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PhotosSearchBrowsePhotoProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PhotosSearchBrowsePhoto",
  "abstractKey": null
};
})();

(node as any).hash = "7ab5c3bac36da50a65fa3713ade21b93";

export default node;
